import { create } from 'zustand'
import { getParts } from '../../getParts'
import { getPartCategories } from '../../getPartCategories'
import { getPartBrands } from '../../getPartBrands'
import type { SparePart, PartCategory, PartBrand } from '@/types'

interface PartsState {
  parts: SparePart[]
  partCategories: PartCategory[]
  partBrands: PartBrand[]
  loading: boolean
  setParts: (parts: SparePart[]) => void
  setPartCategories: (categories: PartCategory[]) => void
  setPartBrands: (brands: PartBrand[]) => void
  fetchParts: () => Promise<void>
  fetchPartCategories: () => Promise<void>
  fetchPartBrands: () => Promise<void>
}

export const usePartsState = create<PartsState>((set) => ({
  parts: [],
  partCategories: [],
  partBrands: [],
  loading: true,
  setParts: (parts) => set({ parts }),
  setPartCategories: (partCategories) => set({ partCategories }),
  setPartBrands: (partBrands) => set({ partBrands }),
  fetchParts: async () => {
    set({ loading: true })
    const parts = await getParts(true)
    set({ parts, loading: false })
  },
  fetchPartCategories: async () => {
    const partCategories = await getPartCategories()
    set({ partCategories })
  },
  fetchPartBrands: async () => {
    const partBrands = await getPartBrands()
    set({ partBrands })
  },
}))
